import { h, Component, Fragment } from "preact";
import Observer from "../../utils/observer";
// import {FiltersRow, InputRow, SelectRow} from "../../utils/table-utils";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import Admin from "../../../../services/admin";
import Config from "../../config";
import User from "../../../../services/user";
import Session from "../../utils/session";
import PageDataFeed from "../../../../services/page-data-feed";

import * as I from "../../utils/icons";
import { MarketingEvents } from "../../../../utils/gtm-module";
import { TelegramButton } from "../../../../services/telegram/openidLogin";
import { t } from "@lingui/macro";

export default class SignupPopup extends Component {
    state = {
        visible: false
    }
    componentWillMount() {
        // Non è il modo di fare questa cosa. Pensi di fare decoupling e ti sei giocato il modo di sapere chi lo apre.
        Observer.subscribe('open-user-signup', this.openSignupListener = () => {
            this.setState({ visible: true });
        });
        Observer.subscribe('hide-user-signup', this.hideSignupListener = () => this.close());
    }
    componentWillUnmount() {
        Observer.unsubscribe('open-user-signup', this.openSignupListener);
        Observer.unsubscribe('hide-user-signup', this.hideSignupListener);
    }
    close() {
        this.setState({ visible: false });
    }
    render() {
        if (!this.state.visible)
            return null;
        return <Overlay onClick={e => this.close()}>
            <SmallModal>
                <ModalHeader>
                    <CloseButton onClick={e => this.close()} />
                    <ModalLogo />
                </ModalHeader>
                <RegisterContent />
            </SmallModal>
        </Overlay>
    }
}

export class RegisterContent extends Component {
    state = {
        success: false
    }
    render() {
        return this.state.success
            ? <RegisterSuccessful userInfo={this.state.userInfo} />
            : <RegisterForm onFinish={userInfo => this.setState({ success: true, userInfo: userInfo })} />
    }
}

export class RegisterSuccessful extends Component {
    render() {
        return <div class="flex flex-col gap-2">
            <div class="w-full px-2 text-center py-3">
                <div class="bg-gray-200 border flex flex-col items-center relative rounded text-base text-center text-slate-950 w-full pt-2">
                    <I.CircleCheck class="h-12 text-green-600" />
                    <span class="uppercase py-2"><Trans>Registration successful!</Trans></span>
                    <span class="py-2 text-xs"><Trans>Close this popup to start playing</Trans></span>
                </div>
            </div>
        </div>
    }
}

export class RegisterForm extends Component {
    state = {
        input: {
            email: '',
            firstname: '',
            residence_country: '',
            birth_date: '',
            residence_city: '',
            residence_cap: '',
            residence_address: '',
            residence_housenumber: ''
        },
        hasError: false,
        error: null,
        sending: false,
        otpcode: null,
        step: 1,
        continueData: null
    }
    static errors = {
        "username": msg`This Username already exists. If you lost your password click on "Recover"`,
        "phone": msg`Please use a valid phone number`,
        "user-exists": msg`This user is already registered`,
        "rate-limit": msg`You have attempted signup too many times. Please wait and try again later`,
        "invalid-otp": msg`This OTP is incorrect. Please try again`,
        "repeated-invalid-otp": msg`You entered a wrong OTP to many times. Please start again`
    }

    async _submitAccountData() {
        this.state.hasError = false;
        this.state.error = null;
        this.setState(this.state);

        const formData = new FormData(this.form);
        const values = {
            username: formData.get('username').trim(),
            password: formData.get('password'),
            confirmPassword: formData.get('confirmPassword'),
            email: '',
            firstname: '',
            residence_country: '',
            birth_date: '',
            residence_city: '',
            residence_cap: '',
            residence_address: '',
            residence_housenumber: ''
        };
        if (values.password != values.confirmPassword) {
            this.state.hasError = true;
            this.state.error = window.Translation(msg`Le password non coincidono`);
            this.setState(this.state);
            return;
        }
        if (values.password.length < 6) {
            this.state.hasError = true;
            this.state.error = window.Translation(msg`La password è troppo corta`);
            this.setState(this.state);
            return;
        }

        try {
            const registerRequest = await this._apiSignup(values);
            this.state.continueData = values;
            return values;
        } catch (error) {
            // _apiSignup lancia una stringa con gli errori separati da virgola
            error = error.split(',')[0];
            this.state.hasError = true;
            this.state.error = RegisterForm.errors[error] ? window.Translation(RegisterForm.errors[error]) : error;
            this.setState(this.state);
        }
        return null;
    }

    async _apiSignup(values) {
        const signupRequest = Config.requireOTP ? User.websiteSignupStart : User.websiteSignup;
        return await signupRequest(
            values.username,
            values.password,
            values.confirmPassword,

            values.email,
            '+251' + values.username,

            values.firstname,
            values.lastname,

            Config.defaultCurrency,

            values.residence_country,
            'm',
            values.birth_date,
            values.residence_city,
            values.residence_cap,
            values.residence_address + (!!values.residence_housenumber ? ' (' + values.residence_housenumber + ')' : ''),

            'on', 'on', 'on'
        );
    }
    async _completeRegistration(values) {
        return await User.websiteSignup(
            values.username,
            values.password,
            values.confirmPassword,

            values.email,
            '+251' + values.username,

            values.firstname,
            values.lastname,

            Config.defaultCurrency,

            values.residence_country,
            'm',
            values.birth_date,
            values.residence_city,
            values.residence_cap,
            values.residence_address + (!!values.residence_housenumber ? ' (' + values.residence_housenumber + ')' : ''),

            'on', 'on', 'on',

            this.state.otpcode
        );
    }

    async _loginNewUser(values) {
        this.props.onFinish(values);
        try {
            const loginAfterRegister = await Session.loginPromise(values.username, values.password);
            window.dispatchEvent(new Event(MarketingEvents.REGISTER_SUCCESS));
            PageDataFeed.rerender();
        } catch (error) {
            alert(error);
        }
    }

    async otpVerification(e) {
        e.preventDefault();
        const formData = new FormData(this.form);
        const otpcode = formData.get('otp');

        try {
            const body = await User.signupVerifyOTP(otpcode);

            if (!body.status || body.status != 'valid') {
                this.state.error = body.status || 'unknown-error';

                if (!!body.data && body.data['attempts-left'] <= 0) {
                    this.state.step = 1;
                    throw 'repeated-invalid-otp';
                } else {
                    throw this.state.error;
                }
            }

            // Tutto ok
            this.state.error = null;
            this.state.otpcode = otpcode;

            await this._completeRegistration(this.state.continueData);
            this._loginNewUser(this.state.continueData);

            this.setState({});
        } catch (error) {
            error = error.split(',')[0];
            this.state.hasError = true;
            this.state.error = RegisterForm.errors[error] ? window.Translation(RegisterForm.errors[error]) : error;
            this.setState(this.state);
        }
    }

    async onSubmitSignup(e) {
        e.preventDefault();
        if (this.state.sending)
            return;

        window.dispatchEvent(new Event(MarketingEvents.REGISTER_START));

        this.setState({});

        if (!e.target.checkValidity()) {
            return;
        }

        this.state.sending = true;
        this.setState({});

        try {
            const values = await this._submitAccountData();
            if (values == null) { return; }

            if (Config.requireOTP) {
                this.setState({ step: 2 })
            } else {
                this._loginNewUser(values);
            }
        } finally {
            this.state.sending = false;
            this.setState({});
        }
    }

    render({ onFinish }) {
        return <div class="flex flex-col gap-2">
            <div class="text-base uppercase w-full text-center py-2"><Trans>Register</Trans></div>
            <div class="w-full px-4 text-center">
                {this.state.step == 1 ? this.renderSignup()
                    : this.state.step == 2 ? this.renderOTP()
                        : null}
            </div>
            
            {!!Config.telegramLogin && <>
                <div class="relative flex justify-center px-4 pt-4 pb-2 text-center">
                    <div class="absolute bottom-4 left-4 right-4 border-b"></div>
                    <div class="z-0 bg-blue-whale-800 px-4 text-sm"><Trans>Oppure</Trans></div>
                </div>
                <div class="px-4">
                    <TelegramButton
                        class="w-full"
                        clientId={Config.telegramLogin}
                        text={t`Register via Telegram`}
                        shape="square"
                        iconOnly={false}
                        onSuccess={e => {
                            Observer.notify('hide-user-signup')
                            PageDataFeed.rerender();
                        }}
                    />
                </div>
            </>}

            <div class="w-full px-2 pb-2 text-center text-sm text-slate-300 flex items-center justify-center">
                <a class="grow-0 text-right" href="/contacts">Support</a>
            </div>
        </div>
    }

    renderSignup() {
        return <form ref={ref => this.form = ref} onSubmit={e => this.onSubmitSignup(e)} key="signup">
            <FormRow>
                <InputLabel>Phone Number</InputLabel>
                <HorizontalInputs>
                    <SmallInput value="ET +251" disabled={true} autocomplete="tel-country-code" class="w-20 bg-slate-200 text-slate-500 border-slate-300" />
                    <Input class="grow" name="username" required={true} autocomplete="tel-national" />
                </HorizontalInputs>
            </FormRow>
            <FormRow>
                <InputLabel>Password</InputLabel>
                <Input placeholder={window.Translation(msg`Password`)} class="grow" type="password" name="password" required={true} autocomplete="new-password" />
            </FormRow>
            <FormRow>
                <InputLabel>Repeat Password</InputLabel>
                <Input placeholder={window.Translation(msg`Repeat Password`)} class="grow" type="password" name="confirmPassword" required={true} autocomplete="new-password" />
            </FormRow>
            <FormRow class="text-xs pt-2">
                <label class="block"><input type="checkbox" name="is-adult" required={true} /> <span><Trans>I confirm I'm over {21} years old</Trans></span></label>
            </FormRow>

            {!this.state.hasError ? null : <div class="w-full px-2 text-center pt-3 mt-2">
                <div class="bg-gray-200 border py-2 relative rounded text-base text-center text-red-600 w-full">
                    <div class="-top-1/3 absolute bg-red-500 border border-red-600 flex font-bold h-8 items-center justify-center left-2 rounded-full text-white text-xl w-8">!</div>
                    <span>{this.state.error}</span>
                </div>
            </div>}

            <div class="w-full px-2 text-center pt-3 mt-2">
                <button type="submit" class="w-full bg-kobaaccent-400 text-kobaaccent-950 py-2 text-center text-base font-bold uppercase hover:bg-kobaaccent-600">
                    <Trans>Register</Trans>
                </button>
            </div>
        </form>;
    }

    renderOTP() {
        return <form ref={ref => this.form = ref} onSubmit={e => this.otpVerification(e)} key="otp">
            <FormRow>
                <InputLabel>OTP Code</InputLabel>
                <HorizontalInputs>
                    <Input class="grow" name="otp" required={true} />
                </HorizontalInputs>
            </FormRow>

            {!this.state.hasError ? null : <div class="w-full px-2 text-center pt-3 mt-2">
                <div class="bg-gray-200 border py-2 relative rounded text-base text-center text-red-600 w-full">
                    <div class="-top-1/3 absolute bg-red-500 border border-red-600 flex font-bold h-8 items-center justify-center left-2 rounded-full text-white text-xl w-8">!</div>
                    <span>{this.state.error}</span>
                </div>
            </div>}

            <div class="w-full px-2 text-center pt-3 mt-2">
                <button type="submit" class="w-full bg-kobaaccent-400 text-kobaaccent-950 py-2 text-center text-base font-bold uppercase hover:bg-kobaaccent-600">
                    <Trans>Check OTP</Trans>
                </button>
            </div>
        </form>;
    }

}


export function Overlay({ onClick, children }) {
    return <div class="fixed top-0 left-0 right-0 bottom-0 z-50 bg-slate-800/50 flex items-center justify-center" onClick={e => e.target == e.currentTarget ? onClick(e) : null}>
        {children}
    </div>
}


export function SmallModal({ children }) {
    return <div class="w-full max-w-sm overflow-auto rounded-lg flex flex-col bg-blue-whale-800 text-slate-100 border border-blue-whale-950">
        {children}
    </div>
}


export function ModalHeader({ children }) {
    return <header class="relative">
        {children}
    </header>
}

export function CloseButton({ onClick }) {
    return <a onClick={onClick} class="top-2 right-2 absolute w-6 h-6 flex items-center justify-center cursor-pointer">
        <I.CloseIcon class="h-3 fill-current" />
    </a>
}

export function ModalLogo({ children }) {
    return <div class="p-2 h-24 w-full">
        <img src={Config.logourl} alt={Config.title} class="object-contain w-full h-full" />
    </div>;
}


export function FormRow({ children, ...props }) {
    return <div class={"text-left " + props['class']}>
        {children}
    </div>
}

export function InputLabel({ children, ...props }) {
    return <label {...props} class={"w-full text-xs " + props['class']}>
        {children}
    </label>
}

export function HorizontalInputs({ children, ...props }) {
    return <div class={"flex " + props['class']}>
        {children}
    </div>
}

export function SmallInput({ children, ...props }) {
    return <input {...props} class={"border h-8 leading-8 py-2 px-3 bg-slate-100 text-slate-950 text-sm " + props['class']} />
}

export function Input({ children, ...props }) {
    return <input {...props} class={"border h-8 w-full leading-8 py-2 px-3 bg-slate-100 text-slate-950 text-sm " + props['class']} />
}

//> Eof